<template>
  <div class="editor-header-grid p-4 pb-0 text-gray-600 text-xs">
    <button
      v-if="isEditMode && !isGridView"
      class="appearance-none bg-transparent p-0 flex uppercase items-center leading-normal place-self-start h-6 gap-1"
      type="button"
      :disabled="!canLeaveEdit"
      @click="$emit('leave-edit-scene')"
    >
      <ChevronLeftIcon class="w-4 h-4" />
      <div class="max-w-38 truncate">{{ deck.title }}</div>
    </button>
    <div v-else class="flex gap-2 uppercase items-center leading-normal">
      <a :href="`${vpeUrl}/decks`" class="flex items-center">
        <ChevronLeftIcon class="w-4 h-4 mr-1" />
        All Decks
      </a>
    </div>
    <div v-if="!isEditMode && deck.updated_at" class="flex justify-center items-center gap-4">
      <p class="italic mb-0" data-testid="deck-editor-last-updated">
        <template v-if="isSaving">Saving&hellip;</template>
        <template v-else>Last updated {{ formatDateTimeMed(deck.updated_at) }}</template>
      </p>
    </div>
    <div v-if="!isEditMode" class="flex items-center justify-end gap-3 uppercase font-medium text-2xs text-center">
      <label
        v-if="deck.request_setting_id && deck.is_book_a_meeting_active"
        class="text-white rounded-full px-4 py-1 mb-0 bg-copper-800 hidden xl_block"
        type="badge"
        data-testid="meeting-booking-enabled"
      >
        Meeting Booking Enabled
      </label>
      <label
        v-else
        class="text-gray-600 rounded-full px-4 py-1 mb-0 bg-gray-300 hidden xl_block"
        type="badge"
        data-testid="meeting-booking-disabled"
      >
        Meeting Booking Disabled
      </label>
      <label v-if="deck.type_tags.length" class="text-white rounded px-2 py-1 mb-0 bg-black" type="badge" data-testid="deck-type-tag">
        {{ deck.type_tags[0] }}
      </label>
      <AccessPermissionBadge :value="deck.view_access_type" font-size="2xs" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { formatDateTimeMed } from '@/lib/datetime-format-utils'
import type { DeepReadonly, PropType } from 'vue'
import type { Deck } from '~/entities/deck'
import { ChevronLeftIcon } from '@heroicons/vue/24/outline'

defineProps({
  deck: {
    type: Object as PropType<DeepReadonly<Omit<Deck, 'slides'>>>,
    required: true,
  },
  isEditMode: {
    type: Boolean,
    default: false,
  },
  isGridView: {
    type: Boolean,
    default: false,
  },
  canLeaveEdit: {
    type: Boolean,
    default: true,
  },
  isSaving: {
    type: Boolean,
    default: false,
  },
})

defineEmits(['leave-edit-scene'])

const { vpeUrl } = useVpeUrl()
</script>

<style lang="stylus" scoped>
a
  color inherit
</style>
